<template>
  <v-dialog v-model="dialog.flag" width="430" scrollable persistent>
    <v-card>
      <v-card-title class="title">
        KYC Details
        <v-spacer></v-spacer>
        <!-- <v-btn
          @click="dialog.flag = false"
          text
          style="min-width: 10px !important"
        >
          <v-icon color="#fff">mdi-close</v-icon>
        </v-btn> -->
      </v-card-title>

      <v-card-text class="pt-7 px-9">
        <v-form ref="submitform">
          <v-row>
            <v-col cols="12">
              <label>
                <span class="label"> PAN </span>
                <span style="color: red">*</span>
              </label>
              <v-text-field
                :rules="[rules.pan_number]"
                v-model="pan"
                outlined
                color="primary"
                placeholder="Enter PAN"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <label>
                <span class="label"> AADHAR Number </span>
                <span style="color: red">*</span>
              </label>
              <v-text-field
                outlined
                v-model="aadhar"
                color="primary"
                type="number"
                :rules="[rules.aadharValidation]"
                placeholder="Enter AADHAR Number"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <label>
                <span class="label"> State </span>
                <span style="color: red">*</span>
              </label>
              <v-select
                :items="state_list"
                v-model="state"
                item-value="id"
                item-text="state"
                outlined
                color="primary"
                :rules="[rules.required]"
                placeholder="Select a State"
                dense
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <label>
                <span class="label"> Mobile Number </span>
                <span style="color: red">*</span>
              </label>
              <v-text-field
                outlined
                v-model="mobile"
                :rules="[rules.phone]"
                color="primary"
                placeholder="Enter Mobile Number"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <label>
                <span class="label"> Email </span>
                <span style="color: red">*</span>
              </label>
              <v-text-field
                :rules="[rules.email]"
                v-model="email"
                outlined
                color="primary"
                placeholder="Enter Email"
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          height="46px"
          @click="submit()"
          color="primary"
          :loading="loading"
          block
          style="border-radius: 4px"
          class="text-capitalize"
        >
          Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RULES from "@/common/fieldRules";
import newAxios from "@/api/newAxios";

export default {
  name: "KycDetails",
  props: ["openKyc"],
  data() {
    return {
      dialog: this.openKyc,
      loading: false,
      state_list: [],
      rules: RULES,
      pan: "",
      aadhar: null,
      state: "",
      mobile: null,
      email: "",
    };
  },

  mounted() {
    this.getStateList();
  },

  methods: {
    getStateList() {
      const onSuccess = (res) => {
        this.state_list = res.data;
      };
      const onFailure = () => {};
      let params = {};

      newAxios("get", "/master/state_list/", {
        params: params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },

    submit() {
      if (this.$refs.submitform.validate()) {
        this.loading = true;
        const onSuccess = () => {
          this.eventBus.$emit("refresh-group-detail");
          this.loading = false;
        };
        const onFailure = () => {
          this.loading = false;
        };
        let formdata = {};

        formdata["group"] = parseInt(this.$route.params.id);
        formdata["PAN"] = this.pan;
        formdata["aadhar"] = this.aadhar;
        formdata["state"] = this.state;
        formdata["mobile"] = this.mobile;
        formdata["email"] = this.email;
        newAxios("post", "/api/payment-kyc-detail/", {
          data: formdata,
          onSuccess,
          onFailure,
          isTokenRequired: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800;
  // line-height: 17.76px;
  text-align: left;
  color: #333333bd;
}
.title {
  background: #2d8cff;
  color: #fff;
  font-weight: bold;
  font-size: 1.25rem;
  font-weight: bold;
  font-family: "Avenir";
}
</style>
